// extracted by mini-css-extract-plugin
module.exports = {"newsCategoriesSingle":"NewsSingleCategory_newsCategoriesSingle__P46wS","newsCategoriesSingleActive":"NewsSingleCategory_newsCategoriesSingleActive__hbZjg"};